module.exports = __webpack_public_path__ + "img/desc6.aae9d402.png";